"use client";

import { ApplicantPrivacyNoticeContent } from "@/components/terms/applicant-privacy-notice-content";
import { TermsTabs } from "@/components/terms/terms-tabs";
import { Separator } from "@/components/ui/separator";
import { setPageTitle } from "@/lib/page-titles";
import { useEffect } from "react";

export default function ApplicantPrivacyNoticePage() {
  useEffect(() => {
    setPageTitle("Applicant Privacy Notice");
  }, []);

  return (
    <div className="bg-ui-bg-subtle min-h-screen">
      <div className="container mx-auto max-w-4xl px-6 py-8">
        <div className="mb-8">
          <div className="flex flex-col items-center text-center">
            <img
              src="/logos/Symbolica-Logo_FullLockup_White.svg"
              alt="Symbolica Logo"
              width={200}
              height={50}
              className="mb-6"
            />
            <p className="font-arizona-sans mb-2 text-[14px] font-normal uppercase tracking-[0.08em] text-[#FFFDF9]/80">
              Symbolica AI Limited
            </p>
            <h1 className="font-arizona-sans mb-2 text-[32px] font-normal leading-[100%] tracking-[-0.64px] text-[#FFFDF9]">
              Applicant Privacy Notice
            </h1>
            <p className="text-muted-foreground text-sm">
              Last updated: July 2026
            </p>
          </div>
        </div>

        <div className="mb-8">
          <TermsTabs />
        </div>

        <ApplicantPrivacyNoticeContent />

        <Separator className="my-8" />

        <div className="text-center">
          <p className="text-muted-foreground text-sm">
            For questions about these legal documents, please contact us at{" "}
            <a
              href="mailto:corporate@symbolica.ai"
              className="hover:text-foreground underline"
            >
              corporate@symbolica.ai
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
